import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { VISIT_REQUEST } from 'apis';

const Payment = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { doctorType, description } = useSelector(state => state.visitReq);

    const [ params ] = useSearchParams();
    const status = params.get("status")?.trim() || "";
    const visitCode = params.get("visitCode")?.trim() || "";

    

    return (
        
        <div className={sharedStyles.container}>

        	<div className={[sharedStyles['container-padding'], sharedStyles['pb-24']].join(' ')}>
        		<ShortHeaderWithBackBtn />

                { status === 'OK' ?
                    <>
                        <div className={[formStyles.title, formStyles['mb-24'], formStyles['text-center']].join(' ')}>
                            درخواست شما با موفقیت ثبت شد.
                            <br />
                            به‌ زودی پزشکان نخبه دکتر بیست با شما تماس خواهند گرفت
                        </div>
                		
                        { profile.medicalRecords.insuranceId === null ?
        	               <button onClick={() => navigate('/medical-record', { replace: true })} className={formStyles.button}>تکمیل پرونده پزشکی</button>
                        :
                           <>
                           <button onClick={() => navigate('/medical-record', { replace: true })} className={formStyles.button}>ویرایش پرونده پزشکی</button>
                           <button onClick={() => navigate('/', { replace: true })} className={formStyles.button}>صفحه اصلی</button>
                           </>
                        }
                    </>
                    :
                    <>
                        <div className={[formStyles.title, formStyles['mb-24'], formStyles['text-center']].join(' ')}>
                            متاسفانه پرداخت انجام نشد!
                        </div>

                        <button onClick={() => navigate('/', { replace: true })} className={formStyles.button}>صفحه اصلی</button>
                    </>
                }
        	</div>

		</div>

    );
}

export default Payment;